import { useQuery } from '@tanstack/react-query';

import type { ExposedGetOriginCommentsCountData, Options } from '~/api';
import { exposedGetOriginCommentsCountOptions } from '~/api/@tanstack/react-query.gen';

type Params = Options<ExposedGetOriginCommentsCountData> & { enabled: boolean };

export function useGetCommentsCount({ enabled, ...params }: Params) {
  return useQuery({
    enabled,
    ...exposedGetOriginCommentsCountOptions(params),
  });
}
